import { Typography } from "@mui/material";
import {useTranslation} from "react-i18next";
import {useEffect} from "react";

interface Props {
  amount: number;
  visible: boolean;
}

const AmountDisplay = (props) => {
  const { amount, visible, color,fontSize,fontWeight } = props;
  const { t } = useTranslation();
  const marks = '\u2022' // u2022\u2022\u2022
  return (<>
    <Typography fontWeight={fontWeight} fontSize={fontSize} color={color}
                sx={props?.sx}
                >{!!visible ? `${amount}` : `${marks} ${marks} ${marks} ${marks}`}</Typography>
  </>)
}

export default AmountDisplay